/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import type React from 'react';

import { type PolymorphicCommonProps } from '../_common/types';
import {
  ButtonBase,
  type ButtonVariants,
  type CommonButtonProps,
} from '../button/ButtonBase';

type TextButtonProps = CommonButtonProps & {
  /** Variant of the button */
  variant?: ButtonVariants;
};

export const TextButton = <T extends React.ElementType = 'button'>({
  children,
  as,
  type = 'button',
  isLoading = false,
  variant = 'primary',
  isDisabled = false,
  size = 'medium',
  onClick,
  className,
  style,
  htmlAttributes,
  ref,
  ...restProps
}: PolymorphicCommonProps<T, TextButtonProps>) => {
  return (
    <ButtonBase
      as={as}
      buttonFill="text"
      variant={variant}
      className={className}
      isDisabled={isDisabled}
      isLoading={isLoading}
      onClick={onClick}
      size={size}
      style={style}
      type={type}
      htmlAttributes={htmlAttributes}
      ref={ref}
      {...restProps}
    >
      {children}
    </ButtonBase>
  );
};
